import TopContext from 'top-context';
import AnimateHeightComponent from './AnimateHeight/AnimateHeight';
export const AnimateHeight = AnimateHeightComponent;
export { Accordion } from './Accordion/Accordion';
export { AccordionPanel } from './Accordion/AccordionPanel';
export { AttentionBanner, AttentionBannerProps } from './AttentionBanner/AttentionBanner';
export { AttentionBox, AttentionBoxProps } from './AttentionBox/AttentionBox';
export { SelectableBox } from './Box/SelectableBox';
export {
  SelectableBoxField,
  SelectableBoxFieldProps,
  SelectBoxesMultipleFieldProps,
  SelectBoxesSingleFieldProps,
} from './Box/SelectableBoxField';
export { BoxList } from './BoxList/BoxList';
export { BoxListButtonContainer } from './BoxList/BoxListButtonContainer';
export { BoxListIcon } from './BoxList/BoxListIcon';
export { BoxListItem } from './BoxList/BoxListItem';
export { BoxListStatus } from './BoxList/BoxListStatus';
export { BoxListSubtitle } from './BoxList/BoxListSubtitle';
export { BoxListTitle } from './BoxList/BoxListTitle';
export { BoxListTitleGroup } from './BoxList/BoxListTitleGroup';
export { Button, ButtonProps } from './Button/Button';
export { ButtonToolbar } from './Button/ButtonToolbar';
export { CheckboxControlContext, ICheckboxControlContext } from './Checkbox/CheckboxControlContext';
export { CheckboxControlGroup, CheckboxControlGroupProps } from './Checkbox/CheckboxControlGroup';
export { CheckboxField, CheckboxFieldProps } from './Checkbox/CheckboxField';
export { CheckboxInput, CheckboxInputProps } from './Checkbox/CheckboxInput';
export { CoverageBox } from './CoverageBox/CoverageBox';
export { CoverageBoxDropdownSection } from './CoverageBox/CoverageBoxDropdownSection';
export { CoverageBoxPills } from './CoverageBox/CoverageBoxPills';
export { CoverageBoxToggleButton } from './CoverageBox/CoverageBoxToggleButton';
export { CoverageButton } from './CoverageButton/CoverageButton';
export { CoverageList } from './CoverageList/CoverageList';
export { CoverageListItem } from './CoverageList/CoverageListItem';
export { CprField, CprFieldProps } from './CprField/CprField';
export { CprInput, CprInputProps, CprInvalidReasons } from './CprField/CprInput';
export { DateField } from './DateField/DateField';
export { DateInput } from './DateField/DateInput';
export { EmailField, EmailFieldProps } from './EmailField/EmailField';
export { EmailInput, EmailInputProps } from './EmailField/EmailInput';
export { ErrorBoundary, ErrorBoundaryProps } from './ErrorBoundary/ErrorBoundary';
export { ErrorPage } from './ErrorPage/ErrorPage';
export { Field, FieldProps } from './Field';
export { FlosWrapper } from './FlosWrapper/FlosWrapper';
export { FormGroup } from './FormGroup/FormGroup';
export { Header } from './Header/Header';
export { HelpBlock } from './HelpBlock/HelpBlock';
export * from './helper';
export {
  createRequest,
  CreateRequestOptions,
  CreateRequestResult,
  FetchInit,
  fetchJson,
  fetchWithRetry,
  get,
  post,
  put,
} from './helper/ajax';
export { asyncForEach, concatAll, includes } from './helper/array';
export { copyToClipboard, isMicrosoftBrowser, preloadImage, scrollTo } from './helper/dom';
export { formatCprNumber, formatNumber, formatPhone } from './helper/format';
export { callAll, debounce, memoizeOne, throttle } from './helper/fp';
export {
  useId,
  useInterval,
  useLatest,
  useLazyRef,
  usePreloadImage,
  useScrollOnMount,
  useTransientState,
} from './helper/hooks';
export { omit, omitFalsyProps, pick, pickNonPrimitive, pickPrimitive, pickValuesStartWith } from './helper/object';
export { createLoggingAndTrackingMiddleware, Middleware, MiddlewareOptions, Tracker } from './helper/redux';
export { isBool, isDefined, isFunction, isNil, isPrimitive, isString } from './helper/typeguard';
export * from './helper/validate';
export { Input, InputProps } from './Input/Input';
export { InsuranceCompanySelect } from './InsuranceCompanySelect/InsuranceCompanySelect';
export { Label } from './Label/Label';
export { Col } from './Layout/Col';
export { Container } from './Layout/Container';
export { Row } from './Layout/Row';
export { LoadingSpinner, LoadingSpinnerProps } from './LoadingSpinner/LoadingSpinner';
export { Modal, ModalProps } from './Modal/Modal';
export { ModalBody } from './Modal/ModalBody';
export { ModalDialog } from './Modal/ModalDialog';
export { ModalFooter } from './Modal/ModalFooter';
export { ModalHeader } from './Modal/ModalHeader';
export { ModalOverlay } from './Modal/ModalOverlay';
export { NumberField, NumberFieldProps } from './NumberField/NumberField';
export { NumberInput, NumberInputProps } from './NumberField/NumberInput';
export { PhoneField, PhoneFieldProps } from './PhoneField/PhoneField';
export { PhoneInput, PhoneInputProps } from './PhoneField/PhoneInput';
export { IRadioControlContext, RadioControlContext } from './Radio/RadioControlContext';
export { RadioControlGroup, RadioControlGroupProps } from './Radio/RadioControlGroup';
export { RadioInput, RadioInputProps } from './Radio/RadioInput';
export { RangeInput } from './RangeInput/RangeInput';
export { ReceiptTable } from './ReceiptTable/ReceiptTable';
export { ReceiptTableIcon } from './ReceiptTable/ReceiptTableIcon';
export { ResourceContext } from './Resources/ResourceContext';
export { ResourceContextProvider } from './Resources/ResourceContextProvider';
export { Section } from './Section/Section';
export { SectionHeader } from './Section/SectionHeader';
export { MultiSelect, MultiSelectProps } from './Select/MultiSelect';
export { MultiSelectField, MultiSelectFieldProps } from './Select/MultiSelectField';
export { Select, SelectProps } from './Select/Select';
export { SelectField, SelectFieldProps } from './Select/SelectField';
export { StepNav } from './StepNav/StepNav';
export { StepNavItem } from './StepNav/StepNavItem';
export { SvgIcon } from './SvgIcon/SvgIcon';
export { TextaraProps, Textarea } from './Textara/Textara';
export { TextareaField, TextareaFieldProps } from './TextareaField/TextareaField';
export { TextField, TextFieldProps } from './TextField/TextField';
export { Tooltip, TooltipProps } from './Tooltip/Tooltip';
export { Logger } from './type';

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      'flos-date-input': {
        value?: string;
        name?: string;
        placeholder?: string;
        disabled?: boolean;
        required?: boolean;
        label?: string;
        ref?: React.Ref<any>;
        'min-date'?: string;
        'max-date'?: string;
        'input-id'?: string;
        'change-month'?: boolean;
        'no-weekend'?: boolean;
        'disabled-dates'?: string;
        'read-only'?: boolean;
      };
    }
  }
  var topContext: TopContext;
}
